import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'layout-standalone',
    templateUrl: './layout-standalone.component.html',
    styleUrls: ['./layout-standalone.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LayoutStandaloneComponent {

}
